/* What people click on the way to a booking (10.10, the owner: «gjøre det enkelt i kode å følge slike trender og hva folk
   trykker på»). One listener for the whole page, no change to any button. Every event carries the theme's name, so the
   old theme and a new one can be compared side by side in GA4 (Utforsk > Trakt).

   Booking path (the Servicify window, in any theme):
     ll_booking_open      «Velg en tid» (or the sticky Book bar) opened the booking window
     ll_booking_day       a day was chosen in the calendar (first per window)
     ll_booking_time      a time was chosen (first per window)
     ll_booking_details   the name/e-mail step appeared
     ll_booking_submit    the confirm button in that step was pressed
     (the confirmed booking itself is the page view of /pages/takk, laserlab-booking-tracking.js)
   Around it:
     ll_consultation_click   a link or button to a consultation (Gratis konsultasjon, Skinlab)
     ll_book_time_click      «Book time» in the header or the menu
     ll_nav_click            header menu, phone category bar, menu drawer, footer (area = header|catbar|drawer|footer)
     ll_list_book_click      «Book» on a treatment card in a list
     ll_need_filter          a skin-need chip on a list

   Privacy: GA4 gets the events only with the visitor's analytics consent (Shopify's banner), no page view of its own
   (Shopify's Google app already counts pages) and no personal data: only the page path, the treatment's handle and the
   label of what was clicked. Servicify adds its own «Calendar Opened», «Date Selected» and «Timeslot Selected». The same events go to Shopify's customer
   events (Shopify.analytics.publish), where each pixel applies its own consent. */
(() => {
  if (window.LaserlabFunnel) return;
  window.LaserlabFunnel = true;

  const MEASUREMENT_ID = 'G-3LZ4W8GF84';
  const PORTAL = '.servicify-modal-portal';
  const OPEN_TRIGGER = '.servicify-select-a-time-button, .servicify-popup-calendar-button, [data-sticky-book-button]';
  const CONSULT = 'a[href*="/products/gratis-konsultasjon"], a[href*="/products/skinlab-konsultasjon"], a[href*="view=konsultasjon"], .ll-consult-button, [id^="GratisKonsultasjon-"], [id^="SkinlabKonsultasjon-"]';
  const BOOK_TIME = '.book-now-button, .ll-nav-mobile-book';
  const theme = (window.Shopify && window.Shopify.theme && window.Shopify.theme.name) || '';
  let flow = null;

  function allowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
    } catch (error) { return false; }
  }

  function label(el) {
    const text = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return text.slice(0, 60);
  }

  function product() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function send(name, params) {
    const data = Object.assign({ ll_theme: theme, page_path: window.location.pathname, treatment: product() }, params || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) { /* customer events are optional */ }
    // GA4 itself is set up by Shopify's Google app on the same page (its page views use the same gtag); the events
    // only name it as their destination and leave its settings alone.
    if (!allowed() || typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', name, Object.assign({ send_to: MEASUREMENT_ID }, data));
    } catch (error) { /* measurement never blocks the page */ }
  }

  function area(el) {
    if (el.closest('.ll-catbar')) return 'catbar';
    if (el.closest('#MenuDrawer, menu-drawer')) return 'drawer';
    if (el.closest('footer, .footer, #LaserlabFooter')) return 'footer';
    if (el.closest('header, .header')) return 'header';
    return '';
  }

  // One booking window = one flow; each step counts once per window.
  function step(name, params) {
    if (!flow) flow = { steps: {} };
    if (flow.steps[name]) return;
    flow.steps[name] = true;
    send(name, params);
  }

  // Some themes load Shopify's consent API only when the banner needs it; load it so the consent check can answer.
  try {
    const shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }
  } catch (error) { /* without the API nothing is sent to GA4 */ }

  // The name/e-mail step is rendered by the app after a time is chosen: count it when an e-mail field appears. The
  // watcher only runs while a booking window is in use (from the opening click, at most 15 minutes).
  let watcher = null;
  let watchUntil = 0;
  function watchDetails() {
    watchUntil = Date.now() + 15 * 60 * 1000;
    if (watcher) return;
    watcher = new MutationObserver(() => {
      if (Date.now() > watchUntil || (flow && flow.steps.ll_booking_details)) {
        watcher.disconnect();
        watcher = null;
        return;
      }
      if (document.querySelector(`${PORTAL} input[type="email"]`)) step('ll_booking_details');
    });
    watcher.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', (event) => {
    // Only the visitor's own clicks: the sticky Book bar and the queued «Velg en tid» click the real button in code.
    if (!event.isTrusted) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const inPortal = target.closest(PORTAL);
    if (inPortal) {
      if (target.closest('.DayPicker-Day[aria-disabled="false"]')) step('ll_booking_day');
      else if (target.closest('[data-ll-slot], .servicify-slots-scroll > *')) step('ll_booking_time');
      else if (inPortal.querySelector('input[type="email"]') && target.closest('button[type="submit"], .Servicify-NoCheckout-Modal button[data-servicify]')) step('ll_booking_submit');
      return;
    }

    const opener = target.closest(OPEN_TRIGGER);
    if (opener) {
      flow = { steps: {} };
      watchDetails();
      send('ll_booking_open', { placement: opener.matches('[data-sticky-book-button]') ? 'sticky' : 'page' });
      return;
    }

    const consult = target.closest(CONSULT);
    if (consult) {
      send('ll_consultation_click', { placement: area(consult) || (consult.closest('.product__info-wrapper, product-info') ? 'product' : 'page'), link_text: label(consult) });
      return;
    }

    const bookTime = target.closest(BOOK_TIME);
    if (bookTime) {
      send('ll_book_time_click', { placement: area(bookTime) });
      return;
    }

    const chip = target.closest('[data-filter-need-chip]');
    if (chip) {
      send('ll_need_filter', { need: chip.getAttribute('data-filter-need-chip'), selected: chip.getAttribute('aria-pressed') !== 'true' });
      return;
    }

    const link = target.closest('a[href]');
    if (!link) return;
    const where = area(link);
    if (where) {
      send('ll_nav_click', { area: where, link_text: label(link), link_url: link.getAttribute('href') });
      return;
    }
    if (link.matches('.product__card-custom-button') || (/^\s*book\s*$/i.test(link.textContent || '') && link.closest('.product-card, .card-product, [data-filter-card]'))) {
      send('ll_list_book_click', { link_url: link.getAttribute('href') });
    }
  }, true);
})();
